var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "soli-round" },
    [
      _c(
        "v-dialog",
        {
          attrs: {
            fullscreen: _vm.$vuetify.breakpoint.xs ? true : false,
            "content-class": _vm.$vuetify.breakpoint.xs ? "" : "soli-round",
            transition: _vm.$vuetify.breakpoint.smAndDown
              ? "dialog-bottom-transition"
              : "dialog-transition",
            "max-width": "600px",
          },
          on: {
            "click:outside": function ($event) {
              ;[(_vm.dialog = false), _vm.$emit("reset")]
            },
          },
          model: {
            value: _vm.dialog,
            callback: function ($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-btn",
                {
                  staticClass: "ma-3 soli-close soli-grey soli-text-shadow",
                  attrs: { icon: "" },
                  on: {
                    click: function ($event) {
                      ;[(_vm.dialog = false), _vm.$emit("reset")]
                    },
                  },
                },
                [_c("v-icon", [_vm._v("clear")])],
                1
              ),
              _vm._v(" "),
              _c("v-card-title", [_vm._v("Quick Links")]),
              _vm._v(" "),
              _c("v-card-subtitle", [_vm._v("Helpful resources")]),
              _vm._v(" "),
              _c(
                "v-container",
                { staticClass: "pt-0" },
                _vm._l(Object.keys(_vm.linksList), function (title, idx) {
                  return _c(
                    "v-list",
                    { key: idx, attrs: { dense: "" } },
                    [
                      _c(
                        "div",
                        { staticClass: "text-subtitle-2 soli-grey px-4" },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(title) +
                              ":\n                    "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.linksList[title], function (item) {
                        return _c(
                          "div",
                          {
                            key: item.title,
                            staticClass: "text-subtitle-1 px-4",
                          },
                          [
                            _c(
                              "a",
                              { attrs: { href: item.url, target: "_blank" } },
                              [_vm._v(_vm._s(item.title))]
                            ),
                          ]
                        )
                      }),
                    ],
                    2
                  )
                }),
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }